import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { Formik, Field } from 'formik'
import { usePath, usePrevious } from 'lib/core/hooks'
import { Alert, Button, Form, Toast } from 'lib/ui'
import { resetPasswordEmail } from 'lib/core/data/customer/resetPasswordEmail'
import { getSlice } from 'lib/core/data/customer/resetPasswordEmail/selectors'
import * as CustomerStyles from 'components/CustomerStyles'
import { schema, validation } from './schema'

export const ForgotPassword = () => {
  const intl = useIntl()
  const history = useHistory()
  const dispatch = useDispatch()
  const path = usePath()
  const { isFetching, isSuccess, isFailure } = useSelector(getSlice)
  const prevIsFetching = usePrevious(isFetching)

  const handleSubmit = (values: Record<string, string>) => {
    const data = { ...values }

    dispatch(resetPasswordEmail({
      email: data.email
    }))
  }

  useEffect(() => {
    const hasFailed = !isFetching && isFailure && prevIsFetching
    if (hasFailed) {
      Toast.toastFailure({ messageId: 'app.whoops' })
    }
  }, [
    isFailure,
    isFetching,
    prevIsFetching
  ])

  return (
    <CustomerStyles.PublicLayout>
      <CustomerStyles.Title>
        <FormattedMessage
          id='customer.account.forgot.title'
        />
      </CustomerStyles.Title>

      <Formik
        initialValues={schema}
        validationSchema={validation(intl)}
        onSubmit={handleSubmit}
      >
        <Form.Wrapper>
          <Field
            name='email'
            label={intl.formatMessage({
              id: 'customer.account.forgot.label.email'
            })}
            component={Form.Input}
            isRequired
            autoFocus
          />

          {isSuccess && (
            <Alert
              type='success'
            >
              <FormattedMessage
                id='customer.account.forgot.sent'
              />
            </Alert>
          )}

          <div className='actions'>
            <Button
              type='submit'
              isLoading={isFetching}
              isDisabled={isSuccess}
            >
              <FormattedMessage
                id='action.sendResetPassword'
              />
            </Button>

            <Button
              skin={Button.SKIN.OUTLINE}
              isDisabled={isFetching}
              onClick={() => history.push(path.login)}
            >
              <FormattedMessage
                id='action.back'
              />
            </Button>
          </div>
        </Form.Wrapper>
      </Formik>
    </CustomerStyles.PublicLayout>
  )
}
